import { forwardRef } from 'react';
import { AspectRatio } from '@/components/elements/AspectRatio';
import cn from '@/lib/classNames';
import Image, { ImageProps } from 'next/image';

export interface ResponsiveImageProps extends ImageProps {
    aspectRatio?: number;
    addOverlay?: boolean;
}

export const ResponsiveImage = forwardRef<HTMLImageElement, ResponsiveImageProps>(({ className, alt, priority, aspectRatio, addOverlay, ...props }, ref) => (
    <div ref={ref} className={cn('w-full h-full overflow-hidden flex', className)}>
        <AspectRatio ratio={aspectRatio}>
            <Image fill className={`object-cover ${addOverlay ? 'brightness-90' : ''}`} alt={alt} priority={priority} {...props} />
        </AspectRatio>
    </div>
));

ResponsiveImage.displayName = 'ResponsiveImage';
